import contextFromRaw from './contextFromRaw';
import getData from './getData';
import load from './load';

export * from './types';
export { DEFAULT_AUTOCOMPLETE_DATA } from './withDefault';

const autocompleteData = {
  contextFromRaw,
  getData,
  load,
};

export default autocompleteData;
